// we can't use NavigationHistoryEntry.getState() directly because it structurally-clones objects
// and we're using references to allow for reactivity

export const historyState = new Map<string, Map<string, unknown>>();

// @ts-expect-error this should be invisible to our application and only for debugging and userscripts
// oxlint-disable-next-line no-underscore-dangle
window._state = historyState;

export const setHistoryState = <T>(entryId: string, key: string, value: T) => {
	const map = historyState.getOrInsertComputed(entryId, onFirstSet);
	map.set(key, value);
};

const onFirstSet = (entryId: string) => {
	const entry = navigation.entries().find(e => e.id == entryId);
	if (!entry) throw new Error("attempting to create state for invalid navigation entry");

	if (import.meta.env.DEV) console.debug("[data navstate] registering disposal", entry);
	entry.addEventListener("dispose", onDispose);
	return new Map();
};

const onDispose = (dispose: Event) => {
	if (import.meta.env.DEV) console.debug("[data navstate] disposing", dispose.target);

	// oxlint-disable-next-line typescript/no-unsafe-type-assertion
	const entry = dispose.target as NavigationHistoryEntry;
	historyState.delete(entry.id);

	// unsue if necessary but lets clean up after ourselves just in case
	entry.removeEventListener("dispose", onDispose);
};
